var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5935 21.3348H14.0001V26.6682C14.0001 27.4015 13.4001 28.0015 12.6668 28.0015H10.0001C9.2668 28.0015 8.6668 27.4015 8.6668 26.6682V21.3348H3.26013C2.2468 21.3348 1.6068 20.2415 2.09346 19.3548L10.1668 4.77484C10.6735 3.86151 11.9935 3.86151 12.5001 4.77484L15.7335 11.2682L11.4268 19.3548C10.9401 20.2415 11.5801 21.3348 12.5935 21.3348Z",
    fill: "#1DE9B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7402 21.3348H23.3335V26.6682C23.3335 27.4015 22.7335 28.0015 22.0002 28.0015H19.3335C18.6002 28.0015 18.0002 27.4015 18.0002 26.6682V21.3348H19.4069C20.4202 21.3348 21.0602 20.2415 20.5735 19.3548L16.2002 11.2682L19.5002 4.77484C20.0069 3.86151 21.3269 3.86151 21.8335 4.77484L29.9069 19.3548C30.3935 20.2415 29.7535 21.3348 28.7402 21.3348Z",
    fill: "#26A69A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTree);
export default __webpack_public_path__ + "static/media/link-tree.91339b21c93ab892c56ef63a00bc644e.svg";
export { ForwardRef as ReactComponent };